<template>
	<div class="cents">
		<van-nav-bar :title='$t("tjry")' left-arrow safe-area-inset-top style="background-color: #1ABC9C;"
			@click-left="goto" />
		<div class="box">
			
			<!-- 用户姓名 -->
			<div class="nameBox">
				<div class="name">{{$t('yhxm')}}1</div>
				<input type="text" class="nameInput" :placeholder="$t('qsryhxm')" v-model="nameVal" />
			</div>
			<!-- 性别 -->
			<div class="nameBox">
				<div class="name">{{$t('xb')}}</div>
				<input type="text" readonly='read' class="nameInput" style="margin-left: 62px;" :placeholder="$t('qxz')"
					v-model="ganderVal" @click="handleGender" />
				<div class="ganderList" v-if="ganderState">
					<div class="ganderItem" @click="chooseGender('男')">{{$t('nbool')}}</div>
					<div class="ganderItem" style="border-bottom: none;" @click="chooseGender('女')">{{$t('ngril')}}</div>
				</div>
			</div>
			<!-- 手机号码 -->
			<div class="nameBox">
				<div class="name">{{$t('sjhm')}}</div>
				<input type="text" class="nameInput" :placeholder="$t('qsrsjhm')" v-model="mobileVal" />
			</div>
			<!-- 证件号码 -->
			<div class="nameBox">
				<div class="name">{{$t('zjhm')}}</div>
				<input type="text" class="nameInput" :placeholder="$t('qsrzjh')" v-model="numberVal" />
			</div>
			<!-- 工号输入 -->
			<div class="nameBox">
				<div class="name">{{$t('gh')}}</div>
				<input type="text" class="nameInput" :placeholder="$t('qtxgh')" v-model="jobNumberVal" style="margin-left: 58px;"/>
			</div>
			<!-- 卡号输入 -->
			<div class="nameBox">
				<div class="name">{{$t('kh')}}</div>
				<input type="text" class="nameInput" :placeholder="$t('qsrkh')" v-model="cardVal" style="margin-left: 58px;"/>
			</div>
			<!-- 开门密码 -->
			<div class="nameBox">
				<div class="name">{{$t('kmmm')}}</div>
				<input type="text" class="nameInput" :placeholder="$t('qsrkmmm')" v-model="passwprdVal"/>
			</div>
			<!-- 部门选择 -->
			<div class="nameBox">
				<div class="name">{{$t('bmxz')}}</div>
				<input type="text" class="nameInput" :placeholder="$t('qxzbm')" readonly='read' @click="chooseDept"
					v-model="deptName" />
				<van-popup v-model="show" position="bottom" :style="{ height: '50%' }">
					<div style="padding:10px 10px">
						<tree :setting="setting" :nodes="treeDatas" @onClick="onClick" @onCheck="onCheck" />
					</div>
				</van-popup>
			</div>
			<!-- 有效开始时间 -->
			<div class="nameBox">
				<div class="name">{{$t('yxkssj')}}</div>
				<!-- <input type="text" class="nameInput" style="width: 177px;" placeholder="格式:2022-1-1"
					v-model="starTime" /> -->
				<el-date-picker v-model="starTime" type="date" :placeholder="$t('xzrq')" @change="starTimeChange">
				</el-date-picker>
			</div>
			<!-- 有效结束时间 -->
			<div class="nameBox">
				<div class="name">{{$t('yxjssj')}}</div>
				<!-- <input type="text" class="nameInput" style="width: 177px;" placeholder="格式:2022-1-1"
					v-model="endTime" /> -->
				<el-date-picker v-model="endTime" type="date" :placeholder="$t('xzrq')" @change="endTimeChange">
				</el-date-picker>
			</div>
			<!-- 设置头像 -->
			<div class="setImg">
				<div class="setImgTxt">{{$t('sztx')}}</div>
				<div class="setImgContent fileinput-buttom">
					<img :src="img" class="image"/>
					<!-- <img src="../../assets/images/devicebg.png"  class="image" v-else/> -->
					<h5-cropper :option="option" @getbase64Data="getbase64Data" @getblobData="getblobData"
						@getFile="getFile" @canceltailor="canceltailor"></h5-cropper>
				</div>
			</div>
			<div class="line"></div>
			<!-- 确认按钮 -->
			<div class="btn" @click="handleBtn">
				{{$t('bc')}}
			</div>
		</div>
	</div>
</template>

<script>
	import tree from "vue-giant-tree";
	import {
		Toast
	} from 'vant';
	import methodlist from "@/utils/methods";
	import jq from 'jquery'
	import H5Cropper from 'vue-cropper-h5'
	var Base64 = require("js-base64").Base64;
	export default {
		data() {
			return {
				UserInfo: JSON.parse(window.localStorage.getItem("getTokendata")), // 本地缓存 获取用户数据
				User: JSON.parse(window.localStorage.getItem("user")), // 本地缓存 获取用户数据
				headImg:'', // 头像
				ganderVal: '', // 性别选择框 绑定值
				ganderState: false, // 性别选择下拉框 状态
				show: false, // 选择部门 状态
				setting: { // tree 配置
					check: {
						enable: true //树是否带复选框或者单选框
					},
					data: {
						simpleData: {
							enable: true, //是否使用简单数据模式
							pIdKey: "pid" //父级id
						}
					},
					view: {
						showIcon: false,
						addHoverDom: this.addHoverDom,
						removeHoverDom: this.removeHoverDom,
					}
				},
				treeDatas: [], //tree数据
				dept_id: '', // 选择 的部门 id
				deptName: '', // 选择的部门 名字
				nameVal: '', // 用户名 绑定值
				mobileVal: '', // 手机号 绑定值
				numberVal: '', // 证件号 绑定值
				jobNumberVal: '', // 工号 绑定值
				cardVal:'', // 卡号
				passwprdVal:'', // 开门密码
				starTime: '', // 有效时间 绑定值
				endTime: '', // 结束时间 绑定值
				option: {
					outputType: "jpeg",
					fixedBox: false
				},
				faceimg: {
					up_img_name_src: "",
					up_img_name_dst: "",
					person_id: "",
					up_img_flag: 0,
				},
				headers: null,
				img: require('@/assets/images/selectfile.png'),
			}
		},
		components: {
			tree,
			H5Cropper
		},
		mounted() {
			this.getDemp()
			// this.headImg = this.User.head_url
		},
		methods: {
			// 点击保存 调用添加接口
			handleBtn() {
				// console.log(this.ganderVal);
				if (this.nameVal == '') {
					Toast.fail(this.$t('qsryhm'))
				} else if (this.ganderVal == '') {
					Toast.fail(this.$t('qxzxb'))
				} else if (this.mobileVal == '') {
					Toast.fail(this.$t('qsrsjhm'))
				} else if (this.numberVal == '') {
					Toast.fail(this.$t('qsrzjh'))
				} else if (this.jobNumberVal == '') {
					Toast.fail(this.$t('qsrgh'))
				} else if (this.deptName == '') {
					Toast.fail(this.$t('qxzbm'))
				} else if (this.starTime == '') {
					Toast.fail(this.$t('qsryxkssj'))
				} else if (this.endTime == '') {
					Toast.fail(this.$t('qsryxjssj'))
				} else {
					this.personAdd()
				}
			},
			// 添加人员 接口方法
			personAdd() {
				let data = {
					method: 'co.person.add',
					name: this.nameVal,
					agent_id: this.UserInfo.agent_id,
					gender: this.ganderVal=='男'||this.ganderVal=='male'?0:1,
					origin: '',
					birthplace: '',
					type: '',
					card_no: this.cardVal,
					remark: '',
					mobile: this.mobileVal,
					credential_type: '',
					credential: this.numberVal,
					birthday: '',
					nation: '',
					dept_id: this.dept_id,
					door_password: this.passwprdVal,
					start_time: (this.starTime) / 1000,
					end_time: (this.endTime) / 1000,
					number: this.jobNumberVal
				}
				this.$https(data).then(res => {
					console.log(res)
					if (res.data.code == 0) {
						Toast.success(this.$t('tjcg'))
						let dataInfo = {
							method: 'co.wx.face.update',
							signature:'',
							user_id:res.data.data.id,
							pic_url:this.faceimg.up_img_name_src
						}
						this.$serve(dataInfo).then(res1=>{
							console.log(res1)
							console.log('上传图片接口成功');
							let data3={
								method: 'co.person.more.approve',
								id: res.data.data.id,
								agent_id:  this.UserInfo.agent_id,
								manager_id: this.UserInfo.manager_id
							}
							this.$serve2(data3).then(res2=>{ 
								console.log(res2)
							})
						})
					} else if (res.data.code == -4) {
						Toast.fail(this.$t('ryycz'))
					} else if (res.data.code == -14) {
						Toast.fail(this.$t('khycz'))
					} else if (res.data.code == -18) {
						Toast.fail(this.$t('zcsbbcz'))
					} else if (res.data.code == -20) {
						Toast.fail(this.$t('ghycz'))
					}
				})
			},
			// 修改时间
			// 开始
			starTimeChange(e){
				console.log(e.getTime()/1000);
				console.log(this.starTime)
				this.starTime = e.getTime()
				console.log(this.starTime)
			},
			// 结束
			endTimeChange(e){
				console.log(e.getTime()/1000);
				this.endTime = e.getTime()
			},
			// 返回上一页
			goto() {
				this.$router.go(-1)
			},
			// 性别选择后 赋值
			chooseGender(text) {
				
				this.ganderVal = text
				if(text=='男'){
					this.ganderVal = this.$t('nbool');
				}else{
					this.ganderVal = this.$t('ngril');
				}
				this.ganderState = false
			},
			// 点击性别 选择框 控制性别选择下拉框 状态
			handleGender() {
				this.ganderState = !this.ganderState
			},
			// 出现部门选择 弹窗
			chooseDept() {
				this.show = true
			},
			// 点击部门框
			onClick(evt, treeId, ) {
				console.log(`1`, evt)
				console.log(`2`, treeId)
			},
			// 选择部门
			onCheck: function(evt, treeId, treeNode) {
				console.log(`3`, treeNode.id)
				this.deptName = treeNode.name
				this.dept_id = treeNode.id
			},
			// 获取部门列表
			getDemp() {
				let data = {
					method: 'co.wx.dept.list',
					user_id: this.UserInfo.user_id,
					agent_id: this.UserInfo.agent_id
				}
				this.$serve(data).then(res => {
					this.treeDatas[0] = this.getFirstObj(res.data.data)
				})
			},
			// 对象 变数组
			getFirstObj(obj) {
				for (var key in obj) {
					return obj[key];
				}
			},
			//  裁剪后base64返回
			getbase64Data(data) {
				this.img = data;
				console.log(`0`, data)
			},
			getblobData(data) {
				console.log(`1`, data)
			},
			getFile(data) {
				let filex = data
				var reader = new FileReader();
				let _this = this;
				reader.readAsDataURL(filex);
				reader.onload = function(e) {
					let es = e.target.result;
					let mqttInfo =
						_this.UserInfo.mqtt_serial + ":" + _this.UserInfo.mqtt_password;
					let curTimestamp = new Date().getTime();
					_this.faceimg.up_img_name_src = methodlist.type_face + curTimestamp + ".jpeg";

					let up_url_Path = methodlist.upload_img_base + _this.faceimg.up_img_name_src;

					_this.action = up_url_Path;
					var data = "temporary=true&imgBase64=" + es.substring("data:image/jpeg;base64,".length);
					_this.headers = {
						Authorization: "Basic " + Base64.encode(mqttInfo),
						"Content-MD5": _this.$md5(data),
						"Content-Type": "application/x-www-form-urlencoded",
					};
					jq.ajax({
						headers: {
							Authorization: "Basic " + Base64.encode(mqttInfo),
							"Content-MD5": _this.$md5(data),
						},
						url: "https://web.fondcard.net/open/store/api.php?" + _this.faceimg.up_img_name_src,
						type: "POST",
						contentType: "application/x-www-form-urlencoded",
						data: data,
						success: function(res) {
							Toast.success(this.$t('scgg'));
							_this.img = methodlist.resident_pic_base + res;
						},
						error: function(res) {
							console.log(res)
							Toast.fail(this.$t('scsb'));
						},
					});
				}

			},
			canceltailor(data) {
				console.log(`3`, data)
			},
		}
	}
</script>

<style scoped>
	.box {
		padding: 0 15px;
	}

	.setImg {
		display: flex;
		justify-content: space-between;
		border-top: 1px solid #ccc;
		padding: 10px 15px;
	}

	.setImgTxt {
		margin: auto 0;
		color: #555;
	}

	.fileinput-buttom {
		position: relative;
		display: inline-block;
		overflow: hidden;
	}

	.fileinput-buttom input {
		position: absolute;
		left: 0;
		top: 0;
		opacity: 0;
	}

	.upbtn {
		position: absolute;
		left: 0;
		top: 12px;
	}

	.image {
		width: 50px;
		height: 50px;
		border-radius: 50%;
	}

	.nameBox {
		display: flex;
		padding-left: 15px;
		margin: 10px 0 20px;
		position: relative;
		height: 36px;
	}

	.ganderList {
		position: absolute;
		top: 35px;
		right: 24px;
		z-index: 999;
		width: 210px;
		background-color: #ccc;
		border-radius: 0 0 10px 10px;
	}

	.ganderItem {
		padding: 5px;
		text-align: left;
		padding-left: 20px;
		border-bottom: 1px solid #000;
	}

	.name {
		color: #555;
		margin: auto 0;
	}

	.nameInput {
		border: 1px solid #555;
		padding: 5px 10px;
		border-radius: 5px;
		width: 210px;
		margin-left: 30px;
	}

	.line {
		height: 1px;
		background-color: #ccc;
		margin: 0px 0 25px;
	}

	.btn {
		background-color: #1ABC9C;
		color: #fff;
		width: 75px;
		text-align: center;
		height: 30px;
		line-height: 30px;
		font-size: 13px;
		border-radius: 5px;
		margin: 0 auto;
	}

	.cents>>>.van-nav-bar__title {
		color: #fff;
	}

	.cents>>>.van-nav-bar .van-icon {
		color: #fff;
	}
</style>
